import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchDraftResponse } from "./fetchDraftResponse";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError, APIReadingRequestDetails } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

interface Params {
  id: string;
  abortController?: AbortController;
}

export const fetchReadingDetails = createAsyncThunk<APIReadingRequestDetails, Params, ThunkConfig<ApiError>>(
  "fetchReadingDetails",
  async ({ id, abortController }, thunkApi) => {
    const { extra, dispatch, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<APIReadingRequestDetails>(`/api/reading_requests/${id}`, {
        signal: abortController?.signal,
      });

      const { status, colors } = response.data;

      if (status === "OPENED") {
        if (
          !colors.length ||
          (colors.length === 1 && colors.includes("red")) ||
          (colors.length === 1 && colors.includes("green"))
        ) {
          await dispatch(fetchDraftResponse(id));
        }
      }

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
